import { useMemo } from 'react';

import {
  type AdvancedOrderValidationInput,
  type AdvancedValidationResult,
  validateAdvancedOrder,
} from './validation/advanced';
import type { CommonValidationResult } from './validation/common';
import {
  type MarketValidationInput,
  type MarketValidationResult,
  validateMarketSwap,
} from './validation/market';

/** Every code-discriminated validation outcome across trade modes. */
export type ValidationResult =
  | CommonValidationResult
  | MarketValidationResult
  | AdvancedValidationResult;

/** Mode-discriminated normalized input for the rewrite-owned validators. */
export type ValidationInput =
  | ({ readonly mode: 'market' } & MarketValidationInput)
  | ({ readonly mode: 'advanced' } & AdvancedOrderValidationInput);

/** Dispatches validation by the normalized trade mode. */
export function validateTrade(input: ValidationInput): ValidationResult[] {
  return input.mode === 'market' ? validateMarketSwap(input) : validateAdvancedOrder(input);
}

/** Provides memoized mode-dispatched validation for React consumers. */
export function useValidation(input: ValidationInput): readonly ValidationResult[] {
  return useMemo(() => validateTrade(input), [input]);
}
